import { render } from "./TalentList.vue?vue&type=template&id=3b7cf050&scoped=true"
import script from "./TalentList.vue?vue&type=script&lang=js"
export * from "./TalentList.vue?vue&type=script&lang=js"

import "./TalentList.vue?vue&type=style&index=0&id=3b7cf050&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7cf050"]])

export default __exports__